module.exports = __webpack_public_path__ + "img/slide-26.e30e26fd.jpg";